import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '20%',
    maxWidth: 404,
    background: '#fff',
    boxShadow: '1px 1px 9px rgba(0, 0, 0, .29);',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      boxShadow: 'none',
    },
  },
  ul: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  parent: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  contentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 25px 15px 40px',
    background: '#fff',
    boxShadow: '0px 3px 9px #0000001C;',
    [theme.breakpoints.down('md')]: {
      padding: 15,
    },
  },
  label: {
    fontSize: 16,
    color: theme.custom.darkBlue,
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
  child: {
    display: 'block',
    padding: '10px 45px',
    fontSize: 14,
    background: '#F7F7F7',
    color: theme.custom.darkBlue,
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      padding: '10px 25px',
    },
    '&:hover': {
      background: '#eaeaea',
    },
  },
  mainLink: {
    display: 'flex',
    alignItems: 'center',
    height: 60,
    padding: '15px 25px 15px 40px',
    fontSize: 16,
    fontWeight: 600,
    background: '#fff',
    color: theme.custom.darkBlue,
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      padding: 15,
    },
  },
  activeChild: {
    paddingLeft: 40,
    fontWeight: 600,
    borderLeft: `5px solid ${theme.custom.lightBlue}`,
    color: theme.custom.lightBlue,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
    },
  },
  activeMainLink: {
    paddingLeft: 35,
    [theme.breakpoints.down('md')]: {
      padding: 15,
    },
  },
  premisIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  poweredBy: {
    marginRight: -10,
    fontSize: 14,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  anchorOriginTopRightRectangle: {
    right: -15,
    fontFamily: 'NeoSansStd',
    fontSize: 11,
    background: theme.custom.warning,
    color: '#fff',
  },
}));
